<app-network-status-badge />

<div class="auth-wrapper">

  <!-- Brand -->
  <div class="brand">
    <img class="brand-logo" src="assets/Agos-logo-blue.png" alt="AGOS" />
      <p class="brand-subtitle">Weight &amp; Balance System</p>
  </div>

  @if (isFirstTimeSetupPending && !isOnline()) {
    <div class="network-hint">
      <i class="bi bi-wifi-off"></i>
      <span><strong>You're offline.</strong> First-time sign-in needs an internet.</span>
    </div>
  }

  <div class="auth-card">

    <!-- Header -->
    <h2 class="title">Welcome to AGOS Aviation</h2>
    <p class="subtitle">
      Sign in to your account
    </p>

    <!-- Login Form -->
    <form [formGroup]="loginForm" (ngSubmit)="submit()">
      <div class="form-group">
        <label>Username</label>

        <input type="email" class="form-input" placeholder="you@example.com" formControlName="username" />

        <!-- Required error -->
        @if (loginForm.controls['username'].touched &&
        loginForm.controls['username'].errors?.['required']) {
        <div class="text-danger">
          Email is mandatory
        </div>
        }

        @if (loginForm.controls['username'].touched &&
        loginForm.controls['username'].errors?.['pattern']) {
        <div class="error-text">
          Enter a valid email address
        </div>
        }
      </div>


      <div class="form-group">
        <label>Password</label>

        <div class="password-wrapper">
          <input [type]="hidePassword ? 'password' : 'text'" class="form-input" placeholder="Enter your password"
            formControlName="password" />

          @if (hidePassword) {
          <span (click)="hidePassword = !hidePassword">
            <i class="bi bi-eye-fill eye-icon"></i>
          </span>
          } @else {
          <span (click)="hidePassword = !hidePassword">
            <i class="bi bi-eye-slash-fill eye-icon"></i>
          </span>
          }
        </div>

        <!-- Error Message -->
        @if (loginForm.controls['password'].touched && loginForm.controls['password'].errors?.['required']) {
        <div class="text-danger">
          Password is mandatory
        </div>
        }
      </div>


      <div class="options">

        @if (!runtime.IsDesktopApplication) {
        <a routerLink="/forgot-password" class="forgot">
          Forgot password?
        </a>
        }
      </div>

      <div class="error" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

      <button class="primary-btn" type="submit" [disabled]="loading || (isFirstTimeSetupPending && !isOnline())">
        {{ loading ? 'Signing in...' : 'Sign In' }}
      </button>

    </form>
  </div>
</div>